const BASE_URL = process.env.REACT_APP_API_URL

export const getUrl = (endpoint: string) => `${BASE_URL}${endpoint}`

export const getErrorMessage = (error: any) => {
  if (error.response) return { error: error.response.data }
  return { error: "Network error" }
}

export const headers = () => {
  return {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods":
      "GET, POST, PATCH, PUT, DELETE, OPTIONS",
    "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
  }
}
